import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import {
  getScannerStatusByKey,
  ScannerStatusEnum
} from '../../../types/commonTypes';
import styles from './Status.css';

const Status = React.memo(({ status }) => {
  const statusInfo = getScannerStatusByKey(status);
  let labelContent = statusInfo.label;

  // Special case: if status is UNKNOWN, wrap label in tooltip showing the original status value
  if (statusInfo.key === ScannerStatusEnum.UNKNOWN.key) {
    labelContent = (
      <Tooltip
        content={`Unknown status: ${status}`}
        position="top"
        testId="status-unknown-tooltip"
      >
        {statusInfo.label}
      </Tooltip>
    );
  }

  // Special case: if status is PARTIALLYDELETED
  if (statusInfo.key === ScannerStatusEnum.PARTIALLYDELETED.key) {
    labelContent = (
      <Tooltip
        content="Agents associated with this scanner were not all deleted due to a timeout. Please initiate delete again from the actions menu."
        position="top"
        data-test-id="status-partially-tooltip"
      >
        {statusInfo.label}
        <Icon name="info-small" size="xs" className={styles.infoIcon} />
      </Tooltip>
    );
  }

  return (
    <div data-test-id="status-id" className={styles[statusInfo.cssStyle]}>
      {labelContent}
    </div>
  );
});

Status.propTypes = {
  status: PropTypes.string
};

export default Status;
